/* Login changes identity, never the saved artwork or the cart contents. */
((scope) => {
  const account = {
    loginURL(login, root, origin) {
      const url = new URL(login, origin);
      const returnURL = new URL(`${root.replace(/\/$/, '')}/cart?pg_account=review`, origin);
      url.searchParams.set('return_to', `${returnURL.pathname}${returnURL.search}`);
      return url.href;
    },
    async prepare({authenticated, remember, redirect, loginURL, current, claim}) {
      if (!authenticated) {
        if (!remember()) throw new Error('Este navegador não conseguiu guardar o acesso ao Design. Permita o armazenamento e tente novamente antes de entrar na conta.');
        await redirect(loginURL);
        return false;
      }
      if (!current()?.accountLinked) await claim();
      if (!current()?.accountLinked) throw new Error('Não foi possível guardar o Design na sua conta. Tente novamente.');
      return true;
    }
  };
  if (typeof module !== 'undefined') module.exports = account;
  else scope.petgrafCheckoutAccount = account;
})(globalThis);
